const Navbar = () => {
    window.navOpen = false;

    const openBtn = document.querySelector('.navbar-toggle__open');
    const closeBtn = document.querySelector('.navbar-toggle__close');

    openBtn.addEventListener('click', toggleNavbar);
    closeBtn.addEventListener('click', toggleNavbar);

}

const toggleNavbar = () => {
    if (window.navOpen) {
        document.querySelector('body').classList.remove('navbar-open');
        window.navOpen = false;
    } else {
        document.querySelector('body').classList.add('navbar-open');
        window.navOpen = true;
    }
}

export default Navbar;


// WEBPACK FOOTER //
// ./src/js/app/components/Navbar.js